<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('my-shops')">My Shops</inertia-link>
            <span class="text-indigo-400 font-medium">/</span> {{ shop.name}}
        </h1>

        <div class="bg-white shadow overflow-hidden  sm:rounded-lg">

            <div class="px-4 py-5 border-b border-gray-200 sm:px-6 flex">
                <div class="flex-grow">
                    <h3 class="text-lg leading-6 font-medium text-gray-900">
                        Shop/Business Account Information
                    </h3>
                    <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
                        Basic Information
                    </p>
                </div>
                <div class="px-4">
                    <a v-if="shop.status === 'pending'" :href="route('my-shops.edit', shop.id)" class="btn-primary btn-primary cursor-pointer">Edit</a>
                </div>
            </div>
            <div class="px-4 py-5 sm:p-0">
                <div class="w-full">
                  <div v-if="shop.status === 'pending'" class="text-center py-3 px-2 mx-auto text-red-800">
                    THIS ACCOUNT IS PENDING APPROVAL
                  </div>
                </div>
                <dl>
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                            Business/Shop Name
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                            {{ shop.name }}
                        </dd>
                    </div>
                    <div class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                            GST TIN
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                            {{ shop.tin_number || null }}
                        </dd>
                    </div>
                    <div class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                            Business Type
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                            {{ business_types[shop.business_type] || null }}
                        </dd>
                    </div>
                    <div class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                            Location
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                          <p>{{shop.atoll.code }}. {{ shop.island.name || null }}</p>
                        </dd>
                    </div>
                    <div class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5" v-if="user_approved">
                        <dt class="text-sm leading-5 font-medium text-gray-500">
                            Account Status
                        </dt>
                        <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                            {{ shop.status }}
                        </dd>
                    </div>
                </dl>
            </div>
        </div>

      <div class="bg-white rounded shadow overflow-x-auto mt-4">
        <table class="w-full whitespace-nowrap">
          <thead class="text-left font-bold">
            <th class="px-6 py-4">Name</th>
            <th v-if="user_approved" class="px-6 py-4">Mobile</th>
            <th v-if="user_approved" class="px-6 py-4">Email</th>
            <th class="px-6 py-4">Status</th>
          </thead>
          <tbody>
            <tr class="hover:bg-gray-100 focus-within:bg-gray-100" v-for="user in account_users">
              <td class="border-t px-6 py-4">{{ user.first_name }} {{ user.last_name }}</td>
              <td v-if="user_approved" class="border-t px-6 py-4">{{ user.mobile }}</td>
              <td v-if="user_approved" class="border-t px-6 py-4">{{ user.email }}</td>
              <td class="border-t px-6 py-4">
                <span v-if="user.pivot.approved" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-green-100 text-green-800">Approved</span>
                <span v-else class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-yellow-100 text-yellow-800">Pending</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</template>

<script>
  import Layout from '@/Shared/Customers/Layout'
  import LoadingButton from '@/Shared/LoadingButton'
  import SelectInput from '@/Shared/SelectInput'
  import TextInput from '@/Shared/TextInput'

  export default {
    metaInfo: { title: 'Update Shop/Business' },
    layout: Layout,
    components: {
      LoadingButton,
      SelectInput,
      TextInput
    },
    remember: 'form',
    props: {
      business_types: Object,
      atoll_list: Array,
      island_list: Array,
      shop: Object,
      user_approved: Number,
      account_users: Array
    },

    data() {
      return {
        sending: false,
        form: {
          name: this.shop.name,
          tin_number: this.shop.tin_number,
          location: this.shop.location,
          atoll_id: this.shop.atoll_id,
          island_id: this.shop.island_id,
          business_type: this.shop.business_type
        },
      }
    },
    methods: {
      submit() {
        this.sending = true
        this.$inertia.post(this.route('my-shops.update'), this.form)
          .then(() => this.sending = false)
      }
    },
  }
</script>

<style scoped>

</style>
